import React from 'react'

import styled from 'styled-components'

import { Caption, Footnote } from 'components/typography'
import { Author } from 'pages/grow/ZestyClient'
import { GROW_AUTHOR_BIO } from 'utils/testing/testIDs'

type Props = {
  author: Author
}

const Container = styled.div`
  margin-top: 40px;
`

const Name = styled(Footnote)`
  font-weight: 500;
`

const Bio = styled(Caption)`
  line-height: 1.33;
  margin-top: 4px;
`

const AuthorDetails: React.FC<Props> = ({ author }) => (
  <Container data-testid={GROW_AUTHOR_BIO}>
    <Name>By {author.name}</Name>
    <Bio>{author.long_bio}</Bio>
  </Container>
)

export { AuthorDetails }
